import { TaskGrid } from "../../components/TaskGrid/TaskGrid";
import ViewTitle from "../../layout/components/ViewTitle";
import { useParams } from "react-router-dom";
import { useBoardViews } from "../../contexts/views/viewsContext";

export const FavoriteView = () => {
  const { viewId } = useParams();
  const { favoriteViews } = useBoardViews();

  const currentView = favoriteViews.find((v) => v.Id === viewId);

  return (
    <>
      <div>
        <ViewTitle
          viewId={currentView?.Id}
          viewName={currentView.Name}
          allowRenaming={!currentView?.IsSystemView}
          isFavoriteView={true}
        />
      </div>
      <div className="row">
        <TaskGrid
          viewId={currentView?.Id}
          enableSaveView={!currentView?.IsSystemView}
        />
      </div>
    </>
  );
};
